
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/simsvorun",
      function () {
        return require("private-next-pages/um/thjonusta/simsvorun/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/simsvorun"])
      });
    }
  